import { useState } from 'react';

let count = 0;

export function useId() {
  const [id] = useState(() => {
    count += 1;
    const random = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
    return 'id-' + random + '-' + count;
  });
  return id;
}
